import { css } from '@emotion/react';

import { breakpoints } from '@/styles';
import colors from '@/styles/colors';
import { p2r, SecondaryProps } from '@/styles/fonts';

const styles = css`
  display: flex;

  a,
  a:visited {
    ${SecondaryProps}
    font-size: ${p2r(18)};
    color: ${colors.black};
    text-decoration: none;

    &.selected {
      text-shadow: 0.25px 0.1px 0 ${colors.black}, -0.25px -0.1px 0 ${colors.black};
    }
  }

  .links {
    display: flex;
    justify-content: space-between;
    min-width: 500px;

    @media (max-width: ${breakpoints.tablet}px) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      min-width: unset;
      margin: auto;
    }

    .link {
      position: relative;
      display: flex;
      align-items: center;
      padding: ${p2r(30)} 10px;

      @media (max-width: ${breakpoints.tablet}px) {
        flex-direction: column;
        align-items: flex-start;
        padding: ${p2r(10)} 0;

        & > a {
          font-size: ${p2r(30)};
          font-weight: bold;
        }

        a {
          font-size: ${p2r(24)};
        }
      }
    }
  }

  @media (max-width: ${breakpoints.tablet}px) {
    position: absolute;
    top: -100vh;
    right: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    min-width: unset;
    height: 100vh;
    padding: ${p2r(60)} 25px;
    overflow: auto;
    background: ${colors.white};
    transition: all 0.8s ease;

    &.opened {
      top: 0;
    }
  }
`;

export default styles;
